import GhostContentAPI from '@tryghost/content-api'

const {REACT_APP_SERVER_URL, REACT_APP_KEY_ID, REACT_APP_VERSION} = process.env

export const api = GhostContentAPI({
    url: REACT_APP_SERVER_URL,
    key: REACT_APP_KEY_ID,
    version: REACT_APP_VERSION
})